import { Directive, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Directive()
export abstract class AbstractFormComponent {
  @Input() form!: FormGroup;

  @Input() cancelLabel = 'forms.cancel';
  @Output() cancelEvent = new EventEmitter<void>();

  @Input() saveLabel = 'forms.save';
  @Output() saveEvent = new EventEmitter<void>();

  onCancel() {
    this.cancelEvent.emit();
  }

  onSave() {
    this.form.markAllAsTouched();
    if (this.form.valid) {
      this.saveEvent.emit();
    }
  }
}
